module.exports = __webpack_public_path__ + "static/media/addlogobg.b53c5bc3.png";